const actionTypeIdentifier = '69DFFDFF-9E61-43F9-80AA-64DFA5CBC8B8';

export const setBillingAccountHistoryLogsLoading = `SET-BILLING-ACCOUNT-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getBillingAccountHistoryLogs = `GET-BILLING-ACCOUNT-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setBillingAccountHistoryPageSize = `SET-BILLING-ACCOUNT-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetBillingAccountHistory = `RESET-BILLING-ACCOUNT-HISTORY-${actionTypeIdentifier}`;
export const setBillingAccountColSearchStr = `SET-BILLING-ACCOUNT-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;